import { useState } from 'react';

import type { FormSubmitFunction } from '#/components/Form/FormContext';
import type { CmsApiEmailCampaignSignupDoubleBlockData } from '#/modules/cms/api/types/blocks/CmsApiEmailCampaignSignupDoubleBlock';
import type { CmsEmailSignupFormValues } from '#/modules/cms/blocks/EmailCampaignSignupSingle/CmsEmailCampaignSignup';
import { CmsEmailCampaignSignup } from '#/modules/cms/blocks/EmailCampaignSignupSingle/CmsEmailCampaignSignup';
import { postJson } from '#/utils/http/postJson';

import {
  CmsEmailCampaignSignupDoubleBlockButtonGroup,
  CmsEmailCampaignSignupDoubleBlockToggleButton,
} from './CmsEmailCampaignSignupDoubleBlock.styled';

type Props = {
  blockId: string;
  data: CmsApiEmailCampaignSignupDoubleBlockData;
};

export function CmsEmailCampaignSignupDoubleBlock({
  blockId,
  data: {
    headline,
    toggleTextOne,
    toggleTextTwo,
    buttonTextOne,
    buttonTextTwo,
    bgImage,
  },
}: Props) {
  const [mode, setMode] = useState('initial');
  const [isOne, setIsOne] = useState(true);

  const onSubmit: FormSubmitFunction<CmsEmailSignupFormValues> = ({
    values,
    handleError,
  }) => {
    const postBaseUrl = '/data/website/page-email-signup-double/';
    setMode('submitting');
    const payload = { ...values, index: isOne ? 0 : 1 };
    postJson(postBaseUrl + blockId, payload)
      .then(() => {
        setMode('submitted');

        return undefined;
      })
      .catch((e) => {
        // TODO: Fix this the next time the file is edited.
        // oxlint-disable-next-line @typescript-eslint/no-unsafe-argument
        handleError(e);
        setMode('initial');
      });
  };

  return (
    <CmsEmailCampaignSignup
      disabled={mode === 'submitting'}
      onSubmit={onSubmit}
      headline={headline}
      bgImage={bgImage}
      buttonText={isOne ? buttonTextOne : buttonTextTwo}
      preForm={
        <CmsEmailCampaignSignupDoubleBlockButtonGroup>
          <CmsEmailCampaignSignupDoubleBlockToggleButton
            key="one"
            type="button"
            onClick={() => setIsOne(true)}
            data-selected={isOne ? true : undefined}
            tabIndex={isOne ? -1 : 0}
            data-qa-id="cms-email-campaign-signup-toggle-one"
          >
            {toggleTextOne}
          </CmsEmailCampaignSignupDoubleBlockToggleButton>
          <CmsEmailCampaignSignupDoubleBlockToggleButton
            key="two"
            type="button"
            onClick={() => setIsOne(false)}
            data-selected={!isOne ? true : undefined}
            tabIndex={!isOne ? -1 : 0}
            data-qa-id="cms-email-campaign-signup-toggle-two"
          >
            {toggleTextTwo}
          </CmsEmailCampaignSignupDoubleBlockToggleButton>
        </CmsEmailCampaignSignupDoubleBlockButtonGroup>
      }
      isSubmitted={mode === 'submitted'}
      qaId="cms-email-campaign-signup-double"
    />
  );
}
